import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";
import NotFound from "../notfound/notfound";
import "./template.scss"

const Template = () => {

    const location = useLocation();
    const [data, setPost] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    const parts = location.pathname.split("/").filter(Boolean);
    const post = parts[parts.length - 1]

    useEffect(() => {
        const fetchAllRef = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`https://api.augschoell.com/wp-json/wp/v2/pages?slug=${post}`);
                if (res.data.length === 0) {
                    setNotFound(true);
                } else {
                    setPost(res.data[0]);
                    setNotFound(false);
                }
            } catch (err) {
                console.log(err);
                setNotFound(true);
            } finally {
                setLoading(false);
            }
        };
        fetchAllRef();
    }, [post]);

    if (notFound && !isLoading) {
        return (
            <NotFound />
        );
    }

    return isLoading ? (<div className="loading" />) : (
        <div className="template">
            <Helmet>
                <title>{data.title.rendered} | Jakob Augschöll</title>
            </Helmet>
            <div className="container">
                <motion.div
                    className="header"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    <h2>{data.title.rendered}</h2>
                </motion.div>
                <motion.div
                    className="content"
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    <div className="wp-content" dangerouslySetInnerHTML={{ __html: data.content.rendered }} />
                </motion.div>
            </div>
        </div>
    )
};

export default Template